'use client';

import { Flex, Text } from '@skin-seoul/design-system';
import { SafeLink } from '@/components/ui/SafeLink';
import { FREE_SHIPPING_BANNER_HEIGHT } from '@/components/layout/Header/constants/css.client';
import { CLASSNAME, getActiveHolidayBanner, type HolidayBannerTextPart } from '@skin-seoul/service';
import type { ReactNode } from 'react';
const renderTextParts = (textParts: HolidayBannerTextPart[]): ReactNode => {
  return textParts.map((part, index) => {
    if (part.bold) {
      return <Text as="span" key={index} fontWeight="bold">
          {part.text}
        </Text>;
    }
    return <span key={index}>{part.text}</span>;
  });
};
const FreeShippingBanner = () => {
  const activeHolidayBanner = getActiveHolidayBanner();
  const isPurpleBackground = activeHolidayBanner.background === 'purple';
  const textContent = <Text color="generic.0" fontWeight="regular" textStyle="paragraph.small" textAlign="center" className={CLASSNAME.NOT_TRANSLATE}>
      {renderTextParts(activeHolidayBanner.textParts)}
    </Text>;
  return <Flex alignItems="center" height={`${FREE_SHIPPING_BANNER_HEIGHT}px`} justifyContent="center" transition="all 0.3s" width="100%" {...isPurpleBackground ? {
    backgroundColor: 'primary.600'
  } : {
    bgGradient: 'to-r',
    gradientFrom: '#B86D00',
    gradientTo: '#000000'
  }} data-sentry-element="Flex" data-sentry-component="FreeShippingBanner" data-sentry-source-file="FreeShippingBanner.tsx">
      {activeHolidayBanner.campaignUrl ? <SafeLink href={activeHolidayBanner.campaignUrl} unstyled>
          {textContent}
        </SafeLink> : textContent}
    </Flex>;
};
export default FreeShippingBanner;